import create from 'zustand'
import merge from 'lodash.merge'

export const trucksInitialStore = []

const useTrucksStore = create((set) => ({
  trucks: trucksInitialStore,
  trucksLoading: true,
  setTrucksLoading: (loading) => set({ trucksLoading: loading }),
  setTrucks: (trucks) => set((state) => ({ ...state, trucks, trucksLoading: false })),
  resetTrucks: () => set(() => ({
    trucks: trucksInitialStore,
    trucksLoading: true
  })),
  addTruck: (truck) => set(state => ({ ...state, trucks: [truck, ...state.trucks] })),
  deletePost: (id) => set((state) => ({
    ...state,
    trucks: state.trucks.filter((item) => item.matchedTruck?.id !== id)
  })),
  updateSpecificTrucks: (id, data) => set((state) => ({
    ...state,
    trucks: state.trucks.map((item) => (item.matchedTruck?.id === id ? merge(item, data) : item))
  })),
  setSpecificTrucks: (id, data) => set((state) => ({
    ...state,
    trucks: state.trucks.map((item) => (item.matchedTruck?.id === id ? { ...item, matchedTruck: data } : item))
  }))
}))

export default useTrucksStore
